import { IconBookmark, IconBuildings, IconInfo, IconPencil, IconShare, IconTools } from '@assets/images/icon';
import { IconFacetime, IconTopology } from '@assets/images/main';
import { cameraEdge, camreaServer } from '@assets/images/main/camera';
import { IconCctvOff } from '@assets/images/main/icon';

export default {
  a: [
    { text: '产品介绍', icon: IconInfo },
    { text: '处理架构', icon: IconTopology },
    { text: '视频采集方式', icon: IconFacetime },
    { text: '支持的摄像头数量', icon: IconCctvOff },
    { text: '安装方式', icon: IconTools },
    { text: '适用空间', icon: IconBuildings },
    { text: '推荐使用场景', icon: IconBookmark },
    { text: '主要特点', icon: IconPencil },
    { text: '外部系统对接', icon: IconShare },
  ],

  b: [
    { text: '单一设备集成AI分析与ORBRO OS' },
    { text: 'Edge终端独立运行（含ORBRO OS）' },
    { text: '通过RTSP/ONVIF进行网络视频采集' },
    { text: '最多支持2台摄像头' },
    { text: '只需连接电源与摄像头即可快速安装' },
    { text: '出入口、狭小室内空间、小型场所' },
    { text: '无需服务器、快速部署、基础功能需求现场' },
    { text: '单台设备即可部署和运行，低成本结构' },
    { text: '提供部分API（支持基础对接）' },
  ],

  c: [
    { text: '基于服务器的高性能AI视频分析系统' },
    { text: 'AI Server与ORBRO Server联合运行' },
    { text: '通过RTSP/ONVIF进行网络视频采集' },
    { text: '支持6台以上摄像头（可扩展）' },
    { text: '以机房/监控中心为核心的网络架构' },
    { text: '大型医院、物流中心、政府机构等综合监控场所' },
    { text: '适用于中大型场所的多通道视频分析需求' },
    { text: '与ORBRO OS高级功能（SOP、热力图、区域管理）全面整合' },
    { text: '提供完整API（支持实时事件/定位/状态对接）' },
  ],

  spec: [
    {},

    {
      image: cameraEdge,
      link: '/camera/edge',
      title: 'ORBRO Edge AI',
      desc: '',
    },

    {
      image: camreaServer,
      link: '/camera/server',
      title: 'ORBRO AI Server',
      desc: '',
    },
  ],
};
